import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { cameraService } from '../../services/central-api/cameras';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    labelFontSize?: number;
}

function CameraTagsDropdown({ value, setValue, zIndex, labelFontSize }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getTags() {
        try {
            const tags = await cameraService.getCameraTagsSimplified();
            setItems(tags.map((tag) => {
                return {
                    value: tag.id,
                    label: tag.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getTags();
    }, []);

    return (
        <FilterDropdown
            label={translate('tags')}
            items={items}
            setValue={setValue}
            value={value}
            multiple={true}
            mode='BADGE'
            zIndex={zIndex}
            labelFontSize={labelFontSize}
        />
    );
}

export default CameraTagsDropdown;
